// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"5671cb77","415":"34c2a5da","854":"1cf625c4","911":"9f57c827"}[chunkId] + ".chunk.js";
};